import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <Navbar bg="white" expand="lg" className="shadow-sm sticky-top mb-4">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2 fw-bold text-dark">
          <FaYoutube size={32} color="#FF0000" />
          <span>YT Downloader</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className="fw-semibold">Home</Nav.Link>
            {/* Add more links if needed */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
